import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { formatCurrency } from "uikit"
import { NavLink } from "react-router-dom"
import "./GenericCard.css"

const SelfEmploymentCard = ({ id, description, ownerName, amount, type }) => (
  <Card>
    <Card.Content>
      <Grid style={{ position: "relative", height: "170px" }}>
        <Grid.Row columns={2} verticalAlign="top">
          <Grid.Column>
            <NavLink
              to={`/organize/income+benefits/incomes/${id}/${type.toLowerCase()}`}
              className="navlink"
            >
              <span className="GenericCard__LinkTitle">
                {description}
                <Icon name="chevron right" size="small" />
              </span>
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="GenericCard__Balance">
              {typeof amount === "number" ? formatCurrency(amount) : amount}
            </p>
            <p className="greyed-text">Annually</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} verticalAlign="bottom">
          <Grid.Column>
            <p className="greyed-text">{ownerName}</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="greyed-text">Self Employment</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

export default SelfEmploymentCard
